export type ClientAuthErrorCode =
  | 'invalidCredentials'
  | 'unexpected'
  | 'notLoggedIn'
  | 'tooManyRetries'
  | 'resetPasswordInvalidLink'
  | 'resetPasswordSocialOnly'
  | 'emailNotVerified';

export abstract class ClientAuthError extends Error {
  protected constructor(public code: ClientAuthErrorCode) {
    super(code);
  }
}

export class AuthUnexpectedError extends ClientAuthError {
  constructor() {
    super('unexpected');
  }
}

export class NotLoggedIn extends ClientAuthError {
  constructor() {
    super('notLoggedIn');
  }
}

export class InvalidCredentialsError extends ClientAuthError {
  constructor() {
    super('invalidCredentials');
  }
}

export class TooManyRetriesError extends ClientAuthError {
  constructor() {
    super('tooManyRetries');
  }
}

export class ResetPasswordInvalidLinkError extends ClientAuthError {
  constructor() {
    super('resetPasswordInvalidLink');
  }
}

export class ResetPasswordSocialOnlyError extends ClientAuthError {
  constructor() {
    super('resetPasswordSocialOnly');
  }
}

export class EmailNotVerifiedError extends ClientAuthError {
  constructor() {
    super('emailNotVerified');
  }
}
